import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { GeneralErrors } from '@feedyou/utils'

import { useOpenBotId } from '../../../store/app'
import { endpointHelpers } from '../../../features/serverBots/endpointHelpers'
import { checkDeployedVersion } from '../../../store/app/actions'

export function useCheckDeployedVersion(): void {
  const botId = useOpenBotId()
  const dispatch = useDispatch()
  const queryResult = endpointHelpers.getConfigurationForCurrentBot.useQuery()

  const { isFetching, isUninitialized } = queryResult
  const apiUrl = queryResult.data?.configuration?.apiUrl

  useEffect(() => {
    if (!botId || isFetching || isUninitialized) {
      return
    }

    if (!apiUrl) {
      console.error(GeneralErrors.InvalidBotApiUrl)
      return
    }

    dispatch(checkDeployedVersion(botId))
  }, [botId, apiUrl, isFetching, isUninitialized, dispatch])
}
